export default __webpack_public_path__ + "static/media/international-academy.cc3f18fb.png";